import { AccountService } from 'src/app/services/user/account.service';
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalController, PickerController } from '@ionic/angular';
import { finalize } from 'rxjs';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { HelperService } from 'src/app/services/helper/helper.service';
import { CountryCode } from 'src/app/models/country-code';
import { CountryCodeModalComponent } from '../modals/country-code-modal/country-code-modal.component';
import { OfferListModalComponent } from 'src/app/modules/shared/modals/offer-list-modal/offer-list-modal.component';
import { PriceInfoModalComponent } from '../modals/price-info-modal/price-info-modal.component';
import { UiService } from 'src/app/services/ui.service';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';
import { localStorageKeys } from 'src/app/services/localStorage/localStorageVariables';
import { SmartDatePipe } from 'src/app/pipes/smart-date.pipe';
import { UserGuestListComponent } from '../user-guest-list/user-guest-list.component';
import countryMeta from 'src/app/data/country-meta';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { GuestCounterModalComponent } from '../modals/guest-counter-modal/guest-counter-modal.component';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
import { GenericModalComponent } from '../modals/generic-modal/generic-modal.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
})
export class DynamicFormComponent implements OnInit {
  @Input() catlogType: string;
  @Input() selectedPassenger: any;
  @Input() offersObject: any;
  @Input() selectedLocation?: string = null;
  @Input() locationList?: any;
  @Input() priceInfo?: any;
  @Input() airportCode?: any;
  @Input() visitTime?: any;
  @Input() visitTimeOptions?: any;
  @Input() travel_date?: any;
  @Input() access_time?: any;
  @Input() selectedLengthOfStay?: any;
  @Input() selectedGuest?: any;

  @Output() isDynamicFormLoaded?: EventEmitter<any> = new EventEmitter();
  @Output() attractionPriceInfo?: EventEmitter<any> = new EventEmitter();
  @Output() submitData = new EventEmitter<any>();
  public selectedOfferTitle: string;
  public selectedOffer: any;
  public campaignId: number;
  public isOfferApplied: boolean;
  public formFieldsData: boolean;
  public userType: any;
  public validBdate: any;
  public userGuestList: any;
  public saveGuest: boolean = false;

  form: FormGroup;
  formData: any;
  formFields: any[];
  isUserPaid: number;
  checkoutMinDate: any;
  private fieldSet: any;
  public selectedCountryCode: any;
  public qtyStringArray: any = [];
  public multiColumnArray: any = [];
  public locationOptions: any[] = [];
  public targetLocation: string;
  public eligiblePaxCount: number;
  public allowedOfferQty: number;
  public initialPriceInfo: any;
  public userInfo: any;
  public defaultValues: any;
  public trackedFlights: any;
  public localStorageService: LocalStorageService;
  public isMultiPax: boolean;
  public isCallingCode: boolean;
  public pid: string;
  public isGuestListModalOpen: boolean = false;
  public tripEndMinDate: any;

  constructor(
    private dynamicFormService: DynamicFormService,
    private modalController: ModalController,
    private uiService: UiService,
    private pickerController: PickerController,
    private helperService: HelperService,
    private smartDatePipe: SmartDatePipe,
    private accountService: AccountService,
    private analyticsService: AnalyticsService,
    private theme: ThemeService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.pid = this.theme.getAppPid;
    const defaultCountryCode = this.theme.getDefaultCountry;
    this.selectedCountryCode = {
      'Adult+1': defaultCountryCode,
    };
    this.formData = {};
    this.multiColumnArray = this.selectedPassenger
      ? { select_guest: this.selectedPassenger }
      : {
          select_guest: { Adult: 1, Children: 0, Infant: 0 },
        };
    if (this.selectedPassenger) {
      this.eligiblePaxCount =
        this.selectedPassenger?.Adult + this.selectedPassenger.Children;
    }
    this.fieldSet = [];
    this.formFieldsData = false;
    this.isMultiPax = false;
    this.getFormData();
    this.validBdate = this.smartDatePipe.transform(
      new Date(),
      'yyyy-MM-dd',
      'en-US'
    );
    const storedGuest = localStorage.getItem('selected_guest');
    this.userInfo = storedGuest
      ? JSON.parse(storedGuest)
      : this.dynamicFormService.getUserInfo;
    this.trackedFlights = this.dynamicFormService.getTrackedFlights;
    this.userType = this.dynamicFormService.getUserInfo.tier?.toLowerCase();
    this.isUserPaid = this.userType === 'premium' ? 1 : 0;
    this.isOfferApplied = false;
    this.allowedOfferQty = this.offersObject?.allowedQty;
    if (this.offersObject?.defaultOfferId) {
      this.applyOffer(this.offersObject?.defaultOfferId);
    }
    const bestOfferId = this.offersObject?.bestOfferId;
    if (
      !this.offersObject?.defaultOfferId &&
      this.offersObject?.offers &&
      bestOfferId
    ) {
      this.applyOffer(bestOfferId);
    }
    if (!this.isObjectEmpty(this.priceInfo)) {
      this.initialPriceInfo = { ...this.priceInfo };
    }
  }

  async getFormData() {
    const loader = await this.uiService.presentGlobalLoading();
    this.dynamicFormService
      .getDynamicForm(this.catlogType)
      .pipe(
        finalize(() => {
          loader.dismiss();
        })
      )
      .subscribe((response: any) => {
        if (
          !response.form_data ||
          response?.form_data?.UserInfo?.form_fields.length === 0
        )
          return;
        if (response?.form_data?.isMultiPax) {
          this.isMultiPax = response?.form_data?.isMultiPax;
          const { Adult, Children } = this.multiColumnArray.select_guest;
          const totalPassenger = [
            ...Array(Adult).fill('Adult'),
            ...Array(Children).fill('Child'),
          ];
          const passengerCount = {};
          const isMobileNumber =
            response?.form_data?.UserInfo?.form_fields?.some(
              (item) =>
                item?.name === 'phone_number' || item?.name === 'mobile_number'
            );
          totalPassenger.forEach((guest) => {
            if (!passengerCount[guest]) {
              passengerCount[guest] = 0;
            }
            const index = passengerCount[guest] + 1;
            passengerCount[guest]++;
            if (index === 1 && guest === 'Adult') {
              this.formData[`${guest}+${index}`] = [
                ...response.form_data.UserInfo.form_fields,
                ...response.form_data.TravelInfo.form_fields,
              ];
              if (isMobileNumber) {
                this.selectedCountryCode[`${guest}+${index}`] = this.theme.getDefaultCountry;
              }
            } else {
              this.formData[`${guest}+${index}`] = [
                ...response.form_data.UserInfo.form_fields,
              ];
              if (isMobileNumber) {
                this.selectedCountryCode[`${guest}+${index}`] = this.theme.getDefaultCountry;
              }
            }
          });
        } else {
          this.formData[`Adult+1`] = [
            ...response.form_data.UserInfo.form_fields,
            ...response.form_data.TravelInfo.form_fields,
          ];
        }
        this.isCallingCode = response?.form_data?.UserInfo?.form_fields?.some(
          (item) => item.name === 'calling_code'
        );
        this.updateFormFields();
      });
  }

  updateFormFields() {
    this.form = new FormGroup({});
    let filteredFlights = [];
    if (this.airportCode) {
      filteredFlights = this.filterFlightsByAirportCode(this.airportCode);
    }
    if (this.locationList?.length > 0) {
      this.locationOptions = this.locationList
        .map((item: any) => item?.locationInfo?.locationName)
        .filter(Boolean);

      if (this.locationList.length === 1 && !this.selectedLocation) {
        this.selectedLocation = this.locationOptions[0];
      }
    }
    Object.entries(this.formData).forEach((element: any, formIndex: number) => {
      element[1].forEach((formField: any, index: any) => {
        this.form.addControl(
          `${element[0]}+${index}+${formField?.name}`,
          this.getValidator(formField)
        );
        let fieldValue: any;
        if (formIndex === 0) {
          fieldValue = this.getFieldValue(formField, filteredFlights);
        }
        if (fieldValue !== undefined) {
          this.form
            .get(`${element[0]}+${index}+${formField?.name}`)
            .setValue(fieldValue);
        }
        if (this.selectedLocation) {
          if (formField?.name === 'terminal') {
            this.form
              .get(`${element[0]}+${index}+${formField?.name}`)
              .disable();
            if (!this.locationOptions.includes(this.selectedLocation)) {
              this.locationOptions.push(this.selectedLocation);
            }
          }
        }
      });
    });
    this.formFields = Object.entries(this.formData);
    this.formFieldsData = true;
    this.isDynamicFormLoaded.emit(true);
  }
  separateNameParts(fullName) {
    const nameParts = fullName.split(' ');
    const lastName = nameParts.pop(); // Remove and return the last element
    const firstName = nameParts.join(' '); // Join the remaining parts

    return {
      lastName,
      firstName,
    };
  }
  private getFieldValue(formField: any, filteredFlights: any[]): any {
    switch (formField.name) {
      case 'name':
        return this.userInfo.name;
      case 'first_name':
        return (
          this.userInfo.name &&
          this.separateNameParts(this.userInfo.name).firstName
        );
      case 'tour_date':
        const date = JSON.parse(
          localStorage.getItem(localStorageKeys.TOUR_EXP_SEARCH_QUERY)
        )?.date;
        const isValidDate = this.helperService.validateDate(
          date,
          formField?.dateOffset
        );
        if (isValidDate) {
          return date;
        }
      case 'last_name':
        return (
          (this.userInfo.name &&
            this.separateNameParts(this.userInfo.name).lastName) ||
          ''
        );
      case 'email':
        return this.userInfo.email;
      case 'calling_code':
        return (
          this.selectedCountryCode?.flag +
          this.selectedCountryCode.dialCode +
          ' ' +
          this.selectedCountryCode.name
        );
      case 'mobile_number':
        return this.userInfo.phoneNo;
      case 'phone_number':
        return this.userInfo.phoneNo;
      case 'travel_date':
        if (this.travel_date) {
          return this.travel_date;
        }
        if (filteredFlights.length > 0) {
          const travelDate = this.dynamicFormService.formatDateString(
            filteredFlights[0].depDayDate
          );
          return travelDate >= formField?.rules?.min ? travelDate : undefined;
        }
        break;
      case 'access_time':
        if (this.access_time) return this.access_time;
      case 'tour_time':
        if (
          this.visitTimeOptions &&
          this.visitTimeOptions.length > 0 &&
          this.visitTime
        ) {
          const isVisitTime = this.visitTimeOptions.find(
            (element: any) => element === this.visitTime
          );
          if (isVisitTime) {
            return this.visitTime;
          }
        }
      case 'terminal':
        return this.selectedLocation || undefined;
      case 'select_guest':
        const defaultValues = this.selectedPassenger || {
          Adult: 1,
          Children: 0,
          Infant: 0,
        };
        this.multiColumnArray['select_guest'] = defaultValues;
        this.qtyStringArray[
          'select_guest'
        ] = `Adult x ${defaultValues?.Adult} Children x ${defaultValues?.Children} Infant x ${defaultValues?.Infant}`;
        return defaultValues;
      case 'flight_no':
        return filteredFlights.length > 0
          ? filteredFlights[0].flight_no
          : undefined;
      default:
        return undefined;
    }
  }
  checkboxfield(values: any) {
    this.isUserPaid = values.currentTarget.checked ? 1 : 0;
  }

  getPassengerTitle(title: any) {
    const adultCount = this.selectedPassenger?.Adult;
    const childrenCount = this.selectedPassenger?.Children;
    const [guest, index] = title.split('+');
    if (adultCount > 1 && guest === 'Adult') {
      return this.getLabel(index, guest);
    }
    if (childrenCount > 1 && guest === 'Child') {
      return this.getLabel(index, guest);
    }
    return guest + ' ' + 'Details';
  }

  getLabel(index: number, guest: string) {
    const mod10 = index % 10;
    const suffix =
      mod10 === 1 ? 'st' : mod10 === 2 ? 'nd' : mod10 === 3 ? 'rd' : 'th';
    return `${index}${suffix} ${guest} Details`;
  }

  filterFlightsByAirportCode(airportCode: string) {
    // Ensure trackedFlights is an array
    if (!Array.isArray(this.trackedFlights)) {
      return [];
    }
    const filteredFlights = this.trackedFlights.filter(
      (flight: { src: string; dest: string }) =>
        flight.src === airportCode || flight.dest === airportCode
    );

    return filteredFlights;
  }

  async presentPicker(item: any) {
    const selectedOptions = item.options.reduce((acc: any, option: any) => {
      acc[option] = this.multiColumnArray?.[item.name]?.[option] ?? 0;
      return acc;
    }, {} as { [key: string]: number });
    const generateColumns = (
      optionsArray: string[],
      selectedOptions: { [key: string]: number }
    ) => {
      return optionsArray.map((option) => {
        const options = [
          {
            text: option,
            value: option === 'Adult' ? 1 : 0,
            disabled: option === 'Adult',
          },
          ...[...Array(10).keys()].map((i) => ({
            text: (i + 1).toString(),
            value: i + 1,
            disabled: false,
          })),
        ];
        const selectedIndex = options.findIndex(
          (opt) => opt.value === selectedOptions[option]
        );
        return {
          name: option,
          options,
          selectedIndex: selectedIndex !== -1 ? selectedIndex : 0,
        };
      });
    };
    const picker = await this.pickerController.create({
      mode: 'ios',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Confirm',
          handler: (selected) => {
            item.options.forEach((option: any) => {
              selectedOptions[option] = selected[option].value;
            });
            if (item.name === 'select_guest') {
              const adultCount = selectedOptions['Adult'] || 0;
              const childrenCount = selectedOptions['Children'] || 0;
              this.eligiblePaxCount = adultCount + childrenCount;
            }
            this.multiColumnArray[item.name] = {
              ...selectedOptions,
            };
            if (this.catlogType === 'attractions') {
              const checkOutData = {
                traveller: {
                  adult: selectedOptions?.Adult,
                  children: selectedOptions?.Children,
                  infant: selectedOptions?.Infant,
                },
                ...(this.visitTime && {
                  visitTime: this.visitTime,
                }),
              };
              localStorage.setItem(
                localStorageKeys.TOUR_EXP_CHECKOUT,
                JSON.stringify(checkOutData)
              );
              this.attractionPriceInfo.emit(this.selectedOffer);
            }
            this.qtyStringArray[item.name] = item.options
              .map((option: any) => `${option} x${selectedOptions[option]}`)
              .join(' ');

            const formControl = this.form.get(item.name);
            if (formControl) {
              formControl.setValue(selectedOptions);
              formControl.markAsTouched();
            }
          },
        },
      ],
      columns: generateColumns(item.options, selectedOptions),
    });
    await picker.present();
  }

  async presentGuestSelector(item: any) {
    const current = this.multiColumnArray?.[item.name] || {
      Adult: 1,
      Children: 0,
      Infant: 0,
    };
    const modal = await this.modalController.create({
      component: GuestCounterModalComponent,
      componentProps: {
        adult: current?.Adult ?? 1,
        child: current?.Children ?? 0,
        infant: current?.Infant ?? 0,
      },
      initialBreakpoint: 0.5,
      breakpoints: [0.5],
      mode: 'ios',
      handle: false,
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    // The component emits via modal.dismiss(), but some flows may not return data
    // So, read from event detail if available
      if (data && (data.adult !== undefined)) {
      const selectedOptions = {
        Adult: data.adult,
        Children: data.child,
        Infant: data.infant,
      };
        this.eligiblePaxCount = (selectedOptions['Adult'] || 0) + (selectedOptions['Children'] || 0);
      this.multiColumnArray[item.name] = { ...selectedOptions };
        this.qtyStringArray[item.name] = ['Adult','Children','Infant']
        .map((opt) => `${opt} x ${selectedOptions[opt] || 0}`)
        .join(' ');

      if (this.catlogType === 'attractions') {
        const checkOutData = {
          traveller: {
            adult: selectedOptions?.Adult,
            children: selectedOptions?.Children,
            infant: selectedOptions?.Infant,
          },
          ...(this.visitTime && {
            visitTime: this.visitTime,
          }),
        };
        localStorage.setItem(
          localStorageKeys.TOUR_EXP_CHECKOUT,
          JSON.stringify(checkOutData)
        );
        this.attractionPriceInfo.emit(this.selectedOffer);
      }
      const formControl = this.form.get(item.name);
      if (formControl) {
        formControl.setValue(selectedOptions);
        formControl.markAsTouched();
      }
    }
  }

  async presentPriceModal() {
    if (this.isObjectEmpty(this.priceInfo)) {
      return this.submitRequest();
    }
    const { origPrice, finalPrice, discount } = this.priceInfo;
    const { eligiblePaxCount, allowedOfferQty } = this;
    let totalPriceInfo = this.priceInfo;
    if (eligiblePaxCount) {
      let origAmount = origPrice * eligiblePaxCount;
      let finalAmount = finalPrice * eligiblePaxCount;
      let totalDiscount = discount * eligiblePaxCount;

      if (allowedOfferQty > 0 && eligiblePaxCount >= allowedOfferQty) {
        const excessPax = eligiblePaxCount - allowedOfferQty;
        finalAmount = finalPrice * allowedOfferQty + origPrice * excessPax;
        totalDiscount = discount * allowedOfferQty;
      }

      totalPriceInfo = {
        ...this.priceInfo,
        origPrice: origAmount,
        finalPrice: finalAmount,
        discount: totalDiscount,
      };
    }
    this.analyticsService.trackUnified('price_info_modal_shown', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'price_info_modal_shown',
      component: 'dynamic-form-component',
      service: this.catlogType,
      priceInfo: totalPriceInfo,
    });
    const modal = await this.modalController.create({
      component: PriceInfoModalComponent,
      componentProps: {
        priceInfo: totalPriceInfo || this.priceInfo,
      },
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      cssClass: 'price-info-modal',
      mode: 'ios',
      handle: false,
    });
    modal.onDidDismiss().then(async (data) => {
      if (data?.data?.proceedForBooking) {
        if(this.theme.getClientName === 'thomascook_fc') {
          this.thomasCookCardModal();
        }else{
          this.submitRequest();
        }
      }
    });
    return await modal.present();
  }

  public async thomasCookCardModal() {
    const modal = await this.modalController.create({
      component: GenericModalComponent,
      componentProps: {
        icon: 'TX_CARD_ICON',
        heading: '',
        message: this.translate.instant('modals.generic_alert.please_use_thomas_cook_forex_card_to_avail_the_offers'),
        returnOkay: true
      },
      cssClass: 'generic-modal',
    });
    modal.onDidDismiss().then(async (data) => {
      if(data?.data){
        this.submitRequest();
      }
    });
    return await modal.present();
  }

  submitRequest() {
    if (this.form.valid) {
      const formData = this.transformData(this.form.value);
      this.analyticsService.trackUnified('checkout_user_details_submitted', {
        flow: 'shared',
        outcome: 'success',
        legacy_event_name: 'checkout user details',
        component: 'dynamic-form-component',
        service: this.catlogType,
        formData: formData,
      });
      if (this.saveGuest) {
        this.accountService
          .addUserGuest(formData, 'dynamic')
          .subscribe((response) => {});
      }
      if (this.catlogType === 'flight_book') {
        this.submitData.emit(formData);
      } else {
        const formValues = {
          ...formData[0],
          ...this.multiColumnArray,
          isPaid: this.isUserPaid,
        };
        const additional_info = {};
        this.submitData.emit({
          ...formValues,
          additional_info: { ...formValues, ...additional_info },
          passenger_info: formData,
          campaignId: this.campaignId,
        });
      }
    }
  }

  private transformData(data) {
    const passengers = {};
    const result = [];

    for (const key in data) {
      const [pax, formIndex, index, field] = key.split('+');
      if (!passengers[pax + formIndex]) {
        passengers[pax + formIndex] = {};
      }

      if (field !== 'select_guest') {
        passengers[pax + formIndex][field] = data[key];
      }

      if (field === 'mobile_number' || field === 'phone_number') {
        passengers[pax + formIndex][field] = data[key];
      }

      if (field === 'calling_code') {
        passengers[pax + formIndex][field] =
          this.selectedCountryCode[pax + '+' + formIndex].dialCode;
      }

      if (pax.includes('Adult')) {
        passengers[pax + formIndex]['type'] = 'adult';
      } else {
        passengers[pax + formIndex]['type'] = 'children';
      }
    }

    for (const pax in passengers) {
      passengers[pax] = {
        ...passengers[pax],
        ...(this.selectedLocation && { terminal: this.selectedLocation }),
        ...(this.selectedLengthOfStay && {
          length_of_stay: this.selectedLengthOfStay,
        }),
      };
      if (result.length === 0) {
        result.push(passengers[pax]);
      } else {
        result.push({ ...result[0], ...passengers[pax] });
      }
    }
    return result;
  }

  private getValidator(formField: any): any {
    switch (formField.type) {
      case 'email':
        return new UntypedFormControl('', [Validators.email]);
      case 'number':
        return new UntypedFormControl('', [
          Validators.pattern(formField?.rules?.pattern),
        ]);
      case 'multicolumn-dropdown':
        const validators = [
          this.multiColumnPickerValidator(
            formField?.rules?.required,
            formField.name
          ),
        ];
        return new UntypedFormControl('', validators);
      case 'date':
        if (formField?.name === 'checkout') {
          this.checkoutMinDate = formField?.rules?.min;
        }
        if (formField?.name === 'trip_end_date') {
          this.tripEndMinDate = formField?.rules?.min;
        }
        if (formField?.rules?.min) {
          return new UntypedFormControl('', [
            this.minDateValidator(formField?.rules?.min),
          ]);
        } else {
          return new UntypedFormControl('', []);
        }
      // case 'text':
      //   if (formField?.name === 'flight_no') {
      //     return new UntypedFormControl('', [
      //       Validators.required,
      //       Validators.pattern('^[A-Z]{2}\\s?[0-9]{2,4}$'),
      //     ]);
      //   }else{
      //     return new UntypedFormControl('', [Validators.nullValidator]);
      //   }
      default:
        return new UntypedFormControl('', [Validators.nullValidator]);
    }
  }
  minDateValidator(minDate: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const inputDate = new Date(control.value);
      const min = new Date(minDate);
      return inputDate >= min ? null : { minDate: { value: control.value } };
    };
  }

  onDateChange(event: any) {
    const checkInCtrl = this.form.get('checkin');
    const checkOutCtrl = this.form.get('checkout');

    if (checkInCtrl && checkOutCtrl) {
      const checkInValue = checkInCtrl.value;
      const checkOutValue = checkOutCtrl.value;

      if (checkInValue) {
        const checkIn = new Date(checkInValue);
        const minCheckoutDate = new Date(checkIn);
        minCheckoutDate.setDate(minCheckoutDate.getDate() + 1);
        const formattedMinCheckoutDate = minCheckoutDate
          .toISOString()
          .split('T')[0];
        if (!checkOutValue || new Date(checkOutValue) < minCheckoutDate) {
          checkOutCtrl.setValue(formattedMinCheckoutDate);
        }
        this.checkoutMinDate = formattedMinCheckoutDate;
      }
    }

    // Handle travel_date and trip_end_date dependency
    const travelDateCtrl = this.findFormControlByFieldName('trip_start_date') || this.findFormControlByFieldName('travel_date');
    const tripEndDateCtrl = this.findFormControlByFieldName('trip_end_date');

    let formattedMinTripEndDate: string | undefined;
    if (travelDateCtrl) {
      const travelDateValue = travelDateCtrl.value;
      if (travelDateValue) {
        const travelDate = new Date(travelDateValue);
        const minTripEndDate = new Date(travelDate);
        minTripEndDate.setDate(minTripEndDate.getDate());
        formattedMinTripEndDate = minTripEndDate
          .toISOString()
          .split('T')[0];
        this.tripEndMinDate = formattedMinTripEndDate;
      }
    }

    if (tripEndDateCtrl && formattedMinTripEndDate) {
      const tripEndDateValue = tripEndDateCtrl.value;
      const minDate = new Date(formattedMinTripEndDate);
      if (!tripEndDateValue || new Date(tripEndDateValue) < minDate) {
        tripEndDateCtrl.setValue(formattedMinTripEndDate);
      }
    }

    return event?.target?.value;
  }

  private findFormControlByFieldName(
    fieldName: string
  ): AbstractControl | null {
    const formControls = Object.keys(this.form.controls);
    const matchingKey = formControls.find((key) =>
      key.endsWith(`+${fieldName}`)
    );
    return matchingKey ? this.form.get(matchingKey) : null;
  }

  multiColumnPickerValidator(
    required: boolean = false,
    itemName: string = ''
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (required) {
        if (itemName === 'select_guest' && value && value['Adult'] === 0) {
          return { required: true, zeroValue: true, adultZero: true };
        }

        if (!value || Object.values(value).every((val) => val === 0)) {
          return { required: true, zeroValue: true };
        }
      }

      return null;
    };
  }
  async selectCountryCode(fieldName: string) {
    const modal = await this.modalController.create({
      component: CountryCodeModalComponent,
    });
    modal.present();

    const { data } = await modal.onWillDismiss();
    if(data){
      this.selectedCountryCode[fieldName] = data || this.selectedCountryCode;
    }
  }

  applyOffer(appliedCampaignId: number) {
    this.campaignId = appliedCampaignId;
    if (this.offersObject?.offers && this.offersObject.offers.length > 0) {
      const offer = this.offersObject?.offers.find(
        (offer: any) => offer.campaignId === appliedCampaignId
      );
      if (offer) {
        const { offerTitle, allowedQty, finalPrice, promoType, promoValue } =
          offer;
        this.selectedOfferTitle = offerTitle;
        this.selectedOffer = offer;
        this.allowedOfferQty = allowedQty;
        if (this.attractionPriceInfo) {
          this.attractionPriceInfo.emit(offer);
        }
        if (!this.isObjectEmpty(this.priceInfo)) {
          this.priceInfo.finalPrice = finalPrice;
          if (promoType === 'DISCOUNT') {
            this.priceInfo.discount = promoValue;
          }
        }
        this.isOfferApplied = true;
      }
    }
  }

  async ShowOffers() {
    this.analyticsService.trackUnified('offers_modal_opened', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'show_offers',
      component: 'dynamic-form-component',
      service: this.catlogType,
    });
    const modal = await this.modalController.create({
      component: OfferListModalComponent,
      componentProps: {
        offerList: this.offersObject?.offers,
      },
      initialBreakpoint: 0.5,
      breakpoints: [0, 0.5, 1],
      mode: 'ios',
    });

    modal.onDidDismiss().then(async ({ data }) => {
      if (data) {
        const loaderInstance = await this.uiService.presentGlobalLoading();
        this.applyOffer(data);
        loaderInstance.dismiss();
      }
    });

    modal.present();
  }
  async removeOffer() {
    this.analyticsService.trackUnified('offer_removed', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'remove_offer',
      component: 'dynamic-form-component',
      service: this.catlogType,
    });
    const loaderInstance = await this.uiService.presentGlobalLoading();
    this.selectedOfferTitle = null;
    this.selectedOffer = null;
    this.attractionPriceInfo.emit();
    if (!this.isObjectEmpty(this.priceInfo)) {
      this.priceInfo = { ...this.initialPriceInfo };
    }
    this.isOfferApplied = false;
    this.applyOffer(this.offersObject.defaultOfferId);
    loaderInstance.dismiss();
  }

  isObjectEmpty(value: {}) {
    if (value == null) {
      return true;
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      return Object.keys(value).length === 0;
    }

    return false;
  }

  showOffersClick(event: any, offersObject: any) {
    this.analyticsService.trackUnified('offer_apply_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'applied_offer',
      button: 'apply_offer_click',
      component: 'dynamic-form-component',
      service: this.catlogType,
      event: event,
      offersObject: offersObject,
    });
  }

  onGuestSelected(guest: any) {
    this.dynamicFormService.setSelectedGuest(guest); // Update the service
  }

  saveGuestCheckboxClick() {
    this.analyticsService.trackUnified('save_guest_checkbox_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'save_guest_checkbox',
      component: 'dynamic-form-component',
      service: this.catlogType,
    });
  }

  async selectfromGuestList(selectedPassengerKey) {
    if (this.isGuestListModalOpen) {
      return;
    }
    this.isGuestListModalOpen = true;
    this.analyticsService.trackUnified('select_guest_list_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'select_guests_from_saved_list',
      component: 'dynamic-form-component',
      service: this.catlogType,
    });
    this.accountService
      .getUserGuestList()
      .pipe()
      .subscribe(async (response: any) => {
        if (!response || !response.userGuests) {
          this.analyticsService.trackResponseError(
            {
              message: 'Empty response received',
              statusCode: 204,
              apiName: 'getUserGuestList',
            },
            'Guest List - Empty Response'
          );
          return;
        }
        this.userGuestList = response.userGuests;
        const modal = await this.modalController.create({
          component: UserGuestListComponent,
          componentProps: {
            userGuestList: this.userGuestList,
          },
        });
        await modal.present();

        const { data } = await modal.onWillDismiss();
        this.isGuestListModalOpen = false;
        if (data) {
          this.analyticsService.trackUnified('guest_selected_from_saved_list', {
            flow: 'shared',
            outcome: 'success',
            legacy_event_name: 'guest_selected_from_saved_list',
            component: 'dynamic-form-component',
            service: this.catlogType,
            userId: data?.userId,
            guestId: data?.id,
            firstName: data?.firstName,
            lastName: data?.lastName,
            type: data?.type,
            abbreviation: data?.abbreviation,
            passportIssuedCountry: data?.passportIssuedCountry,
            passportNo: data?.passportNo,
            dateOfBirth: data?.dob,
            nationality: data?.nationality,
            country: data?.country,
          });
          this.selectedGuest = data;

          this.selectedCountryCode[selectedPassengerKey] =
            countryMeta.find(
              (country) => country.dialCode === data['callingCode']
            ) || this.selectedCountryCode[selectedPassengerKey];
          Object.entries(this.formData).forEach(([passengerKey, fields]) => {
            (fields as any[]).forEach((formField, fieldIndex) => {
              const fieldName = formField.name;
              const camelKey = fieldName.replace(/_([a-z])/g, (_, letter) =>
                letter.toUpperCase()
              );
              const mappedKey =
                camelKey === 'phoneNumber' || camelKey === 'mobileNumber'
                  ? 'phoneNo'
                  : camelKey;

              if (fieldName) {
                const updatedKey = `${selectedPassengerKey}+${fieldIndex}+${fieldName}`;
                const updatedControl = this.form.get(updatedKey);

                if (updatedControl && data[mappedKey] !== undefined) {
                  updatedControl.patchValue(data[mappedKey]);
                }
              }
            });
          });

          this.dynamicFormService.setSelectedGuest(data);
        }
      }, (error) => {
        this.isGuestListModalOpen = false;
      });
  }
}
